import {
  Card,
  GreyGrey10,
  GreyGrey30,
  GreyWhite,
  Box,
  Flex
} from '@sequencehq/core-components'
import { CSSProperties, PropsWithChildren, ReactNode } from 'react'

/**
 * Adapted from the InsightsV2 equivalent initiallty. This component would be good
 * to combine with the charts, in the 'shared-components' library, and move the
 * whole set of chart components to core-components. Or, at the very least, make
 * 'share-components' a clear 'charts' library if for some reason visX disagrees
 * with core-components (like we saw with animation libs).
 *
 * @param param0
 * @returns
 */
const ChartTooltipBase = ({
  children,
  width = '270px',
  'data-testid': dataTestId = 'chartTooltip'
}: {
  children: ReactNode
  width?: string
  'data-testid'?: string
}) => {
  return (
    <Card
      padding="0px"
      backgroundColor={GreyWhite}
      boxShadow="0 2px 4px 0 rgba(15, 23, 42, 0.08)"
      borderRadius="md"
      width={width}
      border={`1px solid ${GreyGrey30}`}
      data-testid={dataTestId}
    >
      {children}
    </Card>
  )
}

const Header = ({ children }: PropsWithChildren) => {
  return (
    <Box
      px="12px"
      py="8px"
      bg={GreyGrey10}
      borderBottom={`1px solid ${GreyGrey30}`}
    >
      {children}
    </Box>
  )
}

const Body = ({
  children,
  ...props
}: { children?: ReactNode } & Pick<CSSProperties, 'padding'>) => {
  return (
    <Flex py={2} px={3} justifyContent="space-between" {...props}>
      {children}
    </Flex>
  )
}

export const ChartTooltip = Object.assign(ChartTooltipBase, {
  Header,
  Body
})
